export const OVERFLOW_CLASSES = {
    auto: 'overflow-auto',
    hidden: 'overflow-hidden',
    clip: 'overflow-clip',
    visible: 'overflow-visible',
    scroll: 'overflow-scroll',
    unset: '[overflow:unset]',
};
